import { InputField } from "@/components/Form";
import SearchPinCode from "./SearchPinCode";
import { useLocation } from "@/hooks";
import useToast from "@/hooks/useToast";
import { ChangeEvent, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { MapPinIc } from "@/components/Elements";

function Location({ register, setValue, reset, watch }: UseFormReturn<any>) {
  const { getAddressDetail, getLocationFromAddress } = useLocation();
  const { showError } = useToast();
  const { location, distanceRadius } = watch();

  useEffect(() => {
    (async () => {
      if (location) {
        const { city, postCode } = await getAddressDetail(location);
        if (city && postCode) setValue("locationDetail", `${postCode}`);
        else setValue("locationDetail", "");
      }
    })();
  }, [location]);

  const onFocusOut = async (event: any) => {
    const location = await getLocationFromAddress({
      postCode: event.target.value,
    });
    if (!location?.lat || !location?.lng) {
      showError("Invalid Location");
      reset((prev: any) => ({
        ...prev,
        location: undefined,
        locationDetail: "",
      }));
      return;
    }
    setValue("location", location);
  };

  return (
    <div>
      <InputField
        type="text"
        placeholder="Location"
        label="Location"
        registration={{
          ...register("locationDetail"),
          onBlur: onFocusOut,
        }}
        icon={
          <SearchPinCode
            location={location}
            radius={distanceRadius}
            onChange={setValue}
          >
            <MapPinIc className="w-6 h-6" />
          </SearchPinCode>
        }
      />
    </div>
  );
}

export default Location;
